module.exports = __webpack_public_path__ + "static/media/grid.c7dde632.jpg";